import React from 'react';
import BaseHeader from './BaseHeader.tsx';

interface SimpleHeaderProps {
  title: string;
}

export default function SimpleHeader(props: SimpleHeaderProps) {
  return (
    <BaseHeader
      title={props.title}
      rightContent={null}
    />
  );
} 